export const liveFilteredTrackedResourcesFixedCacheKey =
  "postUsersMeOrganisationsCurrentTrackedResources";
